import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { DashboardTypes } from "../models/Dashboard";

export const DashboardApi = {
  create: async (request: DashboardTypes.CreateDashboardRequest) => {
    return await jwtAuthAxios().post<DashboardTypes.Dashboard>(
      `/dashboards`,
      request
    );
  },

  update: async (
    id: string,
    request: DashboardTypes.UpdateDashboardRequest
  ) => {
    return await jwtAuthAxios().put<DashboardTypes.Dashboard>(
      `/dashboards/${id}`,
      request
    );
  },

  delete: async (id: string) => {
    return await jwtAuthAxios().delete(`/dashboards/${id}`);
  },
};
